export default "__VITE_ASSET__DRDf2rWz__"